<article class="verify-existing-mobile">
  @switch (imeiApproval) {
    @case (ImeiApprovalType.Unknown) {
      <div class="header">
        <mat-icon [svgIcon]="IconNames.ice_pensive" />
        <div class="heading-text">Bytte inn MobilBytte-telefon</div>
      </div>
      <div class="details">
        <div>Det første vi sjekker er at det er riktig telefon som byttes inn. Det gjør vi med IMEI-nummeret.</div>
        <div>
          <div>1. Be kunden åpne ringe-appen og taste inn</div>
          <div><strong>*#06#</strong></div>
        </div>
        <div>
          <div>2. Er IMEI-nummeret:</div>
          <div>
            <strong>{{ imei }}</strong>
          </div>
        </div>
      </div>
      <div class="buttons">
        <app-ice-button
          color="secondary"
          testId="confirm-matching-number-button"
          width="100%"
          (click)="approveAndNavigateToPhoneSelection()"
        >
          Ja, nummeret er likt
        </app-ice-button>
        <app-ice-button
          color="outlined"
          testId="deny-matching-number-button"
          width="100%"
          (click)="imeiApproval = ImeiApprovalType.Unapproved"
        >
          Nei, jeg ser et annet nummer
        </app-ice-button>
      </div>
    }
    @case (ImeiApprovalType.Unapproved) {
      <div class="header">
        <mat-icon [svgIcon]="IconNames.ice_worried" />
        <div class="heading-text">Ah, da kan vi ikke bytte inn telefonen</div>
      </div>
      <div class="single-button">
        <app-ice-button color="outlined" testId="abort-mobilbytte-button" width="100%" (click)="close(false)">
          Avbryt MobilBytte
        </app-ice-button>
      </div>
    }
  }
</article>
